import { render, staticRenderFns } from "./rating-create-modal.vue?vue&type=template&id=03bda863&scoped=true&"
import script from "./rating-create-modal.vue?vue&type=script&lang=js&"
export * from "./rating-create-modal.vue?vue&type=script&lang=js&"
import style0 from "./rating-create-modal.vue?vue&type=style&index=0&id=03bda863&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bda863",
  null
  
)

export default component.exports